(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("incr-regex-package"), require("react-bootstrap"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "incr-regex-package", "react-bootstrap"], factory);
	else if(typeof exports === 'object')
		exports["RxInput"] = factory(require("react"), require("incr-regex-package"), require("react-bootstrap"));
	else
		root["RxInput"] = factory(root["React"], root["iRX"], root["ReactBootstrap"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 